import { useCsvFileUrl } from '@neo.tax/shared/hooks';

import { CsvUploadInstructions } from '../../../../../csv-upload-instructions';
import { EXAMPLE_DATA_STRINGIFIED, HEADERS_STRINGIFIED } from './accounting-csv-upload.constants';

export const AccountingExpenseCsvUploadInstructions = (): React.ReactElement => {
  const templateCsvUrl = useCsvFileUrl(HEADERS_STRINGIFIED);
  const exampleCsvUrl = useCsvFileUrl(EXAMPLE_DATA_STRINGIFIED);

  return (
    <CsvUploadInstructions
      title="Add all expenses for the current tax year to the template."
      templateCsvUrl={templateCsvUrl}
      templateCsvName="accounting-csv-upload-template.csv"
      exampleCsvUrl={exampleCsvUrl}
      exampleCsvName="accounting-csv-upload-example.csv"
    />
  );
};
